import React from 'react';

const SVG = ({ style = {}, color = 'white', width }) => {
  return (
    <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
      <g>
        <circle fill={color} cx="50%" cy="50%" r="50%" />
        <path
          transform="scale(0.9) translate(8,8)"
          fill="#3b5998"
          d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
        />
      </g>
    </svg>
  );
};

export default SVG;
